// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1___748d9cb7c7b8c720032{/*!*/}.AuthorHeader-cls2___a996a503ea543121fd3{color:#535366;color:var(--text-secondary, #535366)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1___748d9cb7c7b8c720032",
	"cls2": "AuthorHeader-cls2___a996a503ea543121fd3 AuthorHeader-cls1___748d9cb7c7b8c720032"
};
export default ___CSS_LOADER_EXPORT___;
